import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import creditoService from '../../services/creditoService';
import { useGlobalState } from '../../state';
import { toCurrency } from '../../utils/formaters';
import { FaCheckCircle } from 'react-icons/fa';

const STORAGE_KEY = 'idCredito';

const ResultadoCrear: React.FC = () => {
  const navigate = useNavigate();
  const [user] = useGlobalState('user');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const [credito, setCredito] = useState<any | undefined>(undefined);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      setError(undefined);

      if (user === undefined) {
        // waiting for auth
        return;
      }
      if (!user) {
        navigate('/auth/signin');
        return;
      }

      try {
        const idStr = localStorage.getItem(STORAGE_KEY);
        if (!idStr) {
          setError('No se encontró el identificador de la solicitud.');
          setLoading(false);
          return;
        }

        const id = parseInt(idStr, 10);
        if (isNaN(id)) {
          setError('Identificador de solicitud inválido.');
          setLoading(false);
          return;
        }

        const res: any = await creditoService.getCreditoById(id);
        if (res?.success) {
          setCredito(res.data);
        } else {
          setError(res?.errors?.[0] ?? 'No se pudo recuperar la solicitud.');
        }
      } catch (ex: any) {
        setError(ex?.message ?? 'Ocurrió un error al cargar la solicitud.');
      } finally {
        try { localStorage.removeItem(STORAGE_KEY); } catch {}
        setLoading(false);
      }
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <DefaultLayout>
      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl font-semibold mb-4">Solicitud enviada</h1>

          {loading && <Loading statusText="Cargando..." />}

          {error && <Alert type="failure" message={error} />}

          {!loading && !error && credito && (
            <div className="bg-white dark:bg-boxdark p-6 rounded space-y-6 text-center">
              <div className="flex justify-center">
                <FaCheckCircle className="text-6xl text-primario-celeste-800" />
              </div>

              <div>
                <div className="text-lg font-semibold mb-2">¡Tu solicitud fue enviada correctamente!</div>
                <div className="text-sm text-gray-600">
                  En breve nos pondremos en contacto para continuar con el trámite.
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 bg-gray-50 p-4 rounded">
                <div className="text-sm text-left">Número de solicitud</div>
                <div className="text-sm font-bold text-right">#{credito.id}</div>

                <div className="text-sm text-left">Monto solicitado</div>
                <div className="text-sm font-bold text-right">{toCurrency(credito.monto)}</div>

                <div className="text-sm text-left">Monto a recibir</div>
                <div className="text-sm font-bold text-right">{toCurrency(credito.montoNetoARecibir)}</div>

                <div className="text-sm text-left">Cantidad de cuotas</div>
                <div className="text-sm font-bold text-right">{credito.cantidadDeCuotas}</div>

                <div className="text-sm text-left">Teléfono de contacto</div>
                <div className="text-sm font-bold text-right">{credito.telefonoContacto}</div>

                <div className="text-sm text-left">Email de contacto</div>
                <div className="text-sm font-bold text-right">{credito.emailContacto}</div>
              </div>

              <div>
                <button
                  onClick={() => navigate('/')}
                  className="mt-6 inline-flex items-center px-6 py-2 rounded bg-primario-celeste-800 text-white font-semibold hover:bg-primario-azul-900"
                >
                  Volver al inicio
                </button>
              </div>
            </div>
          )}

          {!loading && !error && !credito && (
            <div className="bg-white dark:bg-boxdark p-6 rounded text-center text-gray-600">
              No hay información disponible de la solicitud.
            </div>
          )}
        </div>
      </div>
    </DefaultLayout>
  );
};

export default ResultadoCrear;